import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSwal from "../../../components/Swal/commonSwal";
import TabContent from "../../../components/Tab/TabContent";
import StepsList from "../../../components/steps/StepsList";
import StepsButton from "../../../components/steps/StepsButton";
import TabPane from "../../../components/Tab/TabPane";
import CommonInput from "../../../components/forms/CommonInput";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import {
  handleChange,
  handleChangeFile,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputSenha from "../../../components/forms/CommonInputSenha";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import TabHelper from "../../../helpers/TabHelper";

const DadosPessoaisTab = ({ values, setValues }) => (
  <TabPane id="dadosPessoais" ativo>
    <div className="row">
      <div className="col-lg-6 mb-3">
        <CommonInput
          label="Link do contrato"
          id="link_contrato"
          value={values.link_contrato}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
          disabled
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInputDate
          label="Data de assinatura"
          id="data_assinatura"
          value={values.data_assinatura}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
          disabled
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          label="CPF"
          id="cnpj"
          value={values.cnpj}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          mask="999.999.999-99"
          required
          disabled
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-7 mb-3">
        <CommonInput
          label="Nome completo"
          id="razao_social"
          value={values.razao_social}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
          disabled
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="E-mail"
          id="email"
          value={values.email}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
          disabled
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-2 mb-3">
        <CommonInputDate
          label="Data de nascimento"
          id="data_nascimento"
          value={values.data_nascimento}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="RG"
          id="rg"
          value={values.rg}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInput
          label="Órgão expedidor (RG)"
          id="expedidor_rg"
          value={values.expedidor_rg}
          onChange={(e) => {
            handleChange(e, values, setValues);
          }}
          required
        />
      </div>
      <div className="col-lg-2 mb-3">
        <CommonInputMask
          label="Celular"
          id="celular"
          value={values.celular}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          mask="(99)9 9999-9999"
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInputSenha
          label="Senha Gov.br"
          id="senha_gov"
          value={values.senha_gov}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          mask="99999-999"
          label="CEP"
          id="cep"
          value={values.cep}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="Logradouro"
          id="logradouro"
          value={values.logradouro}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="N°"
          id="numero"
          value={values.numero}
          onChange={(e) => handleChangeNumeral(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="Complemento"
          id="compl"
          value={values.compl}
          onChange={(e) => handleChange(e, values, setValues)}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Bairro"
          id="bairro"
          value={values.bairro}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Cidade"
          id="cidade"
          value={values.cidade}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="UF"
          id="uf"
          value={values.uf}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
    </div>
  </TabPane>
);

const DadosEmpresaTab = ({ values, setValues }) => (
  <TabPane id="dadosEmpresa">
    <div className="row">
      <div className="col-lg-12 mb-3">
        <CommonTextArea
          label="Atividades da empresa"
          id="atividades_empresa"
          value={values.atividades_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          rows={3}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-6 mb-3">
        <CommonInput
          label="Nome fantasia"
          id="nome_fantasia"
          value={values.nome_fantasia}
          onChange={(e) => handleChange(e, values, setValues)}
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          label="Celular"
          id="celular_empresa"
          value={values.celular_empresa}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          mask="(99)9 9999-9999"
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="E-mail"
          id="email_empresa"
          value={values.email_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3 mb-3">
        <CommonInputMask
          mask="99999-999"
          label="CEP"
          id="cep_empresa"
          value={values.cep_empresa}
          onChange={(e) => handleChangeUnmask(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-5 mb-3">
        <CommonInput
          label="Logradouro"
          id="logradouro_empresa"
          value={values.logradouro_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="N°"
          id="numero_empresa"
          value={values.numero_empresa}
          onChange={(e) => handleChangeNumeral(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-3 mb-3">
        <CommonInput
          label="Complemento"
          id="compl_empresa"
          value={values.compl_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Bairro"
          id="bairro_empresa"
          value={values.bairro_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          required
        />
      </div>
      <div className="col-lg-4 mb-3">
        <CommonInput
          label="Cidade"
          id="cidade_empresa"
          value={values.cidade_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
      <div className="col-lg-1 mb-3">
        <CommonInput
          label="UF"
          id="uf_empresa"
          value={values.uf_empresa}
          onChange={(e) => handleChange(e, values, setValues)}
          required
          disabled
        />
      </div>
    </div>
  </TabPane>
);

const DocumentosTab = ({ values, setValues, downloadDocumento }) => (
  <TabPane id="documentosMei">
    <div className="row align-items-center">
      <div className="col-md-6 mb-3">
        <label className="form-label requiredInput">
          CNH (caso não tenha, favor adicionar RG)
        </label>
      </div>
      <div className="col-md-6 mb-3">
        {values?.documento ? (
          <>
            <CommonButton
              color="info"
              onClick={() => {
                downloadDocumento(values?.documento.split(".")[0]);
              }}
              style={{ marginRight: ".25rem" }}
            >
              <i className="mdi mdi-cloud-download d-block font-size-18"></i>
            </CommonButton>
            <CommonButton
              color="danger"
              onClick={() => {
                setValues((prevValues) => ({
                  ...prevValues,
                  cnh_rg_novo: null,
                  documento: null,
                }));
              }}
            >
              <i className="mdi mdi-trash-can d-block font-size-18"></i>
            </CommonButton>
          </>
        ) : (
          <CommonInputFile
            label="Selecione o arquivo"
            accept="application/pdf"
            id="cnh_rg_novo"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            required
            data-arquivo="1"
          />
        )}
      </div>
    </div>
  </TabPane>
);

function ProcessoMeiModal({
  modalHook,
  valuesHook,
  cepApi,
  cepEmpresaApi,
  salvarProcesso,
  tabHook,
  downloadDocumento,
}) {
  const { values, setValues } = valuesHook;
  const { processoMeiModal, setProcessoMeiModal } = modalHook;
  const { getCep, cepResponse } = cepApi;
  const { getCepEmpresa, cepResponseEmpresa } = cepEmpresaApi;
  const { tabAtual, setTabAtual } = tabHook;

  //Busca dados do CEP
  React.useEffect(() => {
    if (!values?.cep || values?.cep.length !== 8) return;
    try {
      getCep(values.cep);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCep, values.cep]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponse) return;
    setValues((values) => ({
      ...values,
      logradouro: cepResponse.logradouro,
      bairro: cepResponse.bairro,
      cidade: cepResponse.localidade,
      uf: cepResponse.uf,
      codigo_cidade: cepResponse.ibge,
    }));
  }, [cepResponse, setValues]);

  //Busca dados do CEP
  React.useEffect(() => {
    if (!values?.cep_empresa || values?.cep_empresa.length !== 8) return;
    try {
      getCepEmpresa(values.cep_empresa);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCepEmpresa, values.cep_empresa]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponseEmpresa) return;
    setValues((values) => ({
      ...values,
      logradouro_empresa: cepResponseEmpresa.logradouro,
      bairro_empresa: cepResponseEmpresa.bairro,
      cidade_empresa: cepResponseEmpresa.localidade,
      uf_empresa: cepResponseEmpresa.uf,
      codigo_cidade_empresa: cepResponseEmpresa.ibge,
    }));
  }, [cepResponseEmpresa, setValues]);

  return (
    <CommonModal
      title="Editar dados"
      is_open_modal={processoMeiModal}
      set_is_open_modal={setProcessoMeiModal}
      size="xl"
      customFooter={
        <div className="modal-footer justify-content-between">
          <div>
            {tabAtual > 0 && (
              <CommonButton
                onClick={() => {
                  TabHelper.trocarTab(tabAtual, setTabAtual, -1);
                }}
                color="primary"
              >
                Anterior
              </CommonButton>
            )}
          </div>
          <div>
            <CommonButton
              color="success"
              onClick={salvarProcesso}
              style={{ marginRight: "0.25rem" }}
            >
              Salvar
            </CommonButton>
            <CommonButton
              onClick={() => {
                setProcessoMeiModal(false);
              }}
              color="danger"
              style={{ marginRight: "0.25rem" }}
            >
              Cancelar
            </CommonButton>
            {tabAtual < 2 && (
              <CommonButton
                onClick={() => {
                  TabHelper.trocarTab(tabAtual, setTabAtual, 1);
                }}
                color="primary"
              >
                Próximo
              </CommonButton>
            )}
          </div>
        </div>
      }
    >
      <StepsList>
        <StepsButton
          href="dadosPessoais"
          step={1}
          onClick={() => {
            setTabAtual(0);
          }}
          ativo
        >
          Dados pessoais
        </StepsButton>
        <StepsButton
          href="dadosEmpresa"
          onClick={() => {
            setTabAtual(1);
          }}
          step={2}
        >
          Dados da empresa
        </StepsButton>
        <StepsButton
          href="documentosMei"
          onClick={() => {
            setTabAtual(2);
          }}
          step={3}
        >
          Documentos do empresário
        </StepsButton>
      </StepsList>
      <TabContent>
        <DadosPessoaisTab setValues={setValues} values={values} />
        <DadosEmpresaTab setValues={setValues} values={values} />
        <DocumentosTab
          setValues={setValues}
          values={values}
          downloadDocumento={downloadDocumento}
        />
      </TabContent>
    </CommonModal>
  );
}

ProcessoMeiModal.propTypes = {
  modalHook: PropTypes.shape({
    processoMeiModal: PropTypes.bool.isRequired,
    setProcessoMeiModal: PropTypes.func.isRequired,
  }).isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.bool.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  cepApi: PropTypes.shape({
    getCep: PropTypes.func.isRequired,
    cepResponse: PropTypes.object,
  }).isRequired,
  cepEmpresaApi: PropTypes.shape({
    getCepEmpresa: PropTypes.func.isRequired,
    cepResponseEmpresa: PropTypes.object,
  }).isRequired,
  salvarProcesso: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
};

DadosPessoaisTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
};

DadosEmpresaTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
};

DocumentosTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
};

export default ProcessoMeiModal;
